/**
 * This is a singleton to ensure we only instantiate Stripe once.
 */

import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null>;

export const getStripe = (isCalmSleepApp?: boolean): Promise<Stripe | null> => {
	if (!stripePromise) {
		if (isCalmSleepApp) {
			stripePromise = loadStripe(process.env.NEXT_PUBLIC_SLEEP_STRIPE_TOKEN as string);
		} else {
			stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_TOKEN as string);
		}
	}
	return stripePromise;
};
